import RecipeDto from "../Common/dtos/RecipeDto";
import { QueryOptions } from "../Common/useQuery";
import useUserOrEmployeeQuery from "../Common/useUserOrEmployeeQuery";
import { useUserOrKaEmployee } from "../UserAccess/useUserOrKaEmployee";

const useGetRecipes = (options?: QueryOptions<RecipeDto[]>) => {
  const { selectedBusiness } = useUserOrKaEmployee();

  return useUserOrEmployeeQuery<RecipeDto[]>(
    { path: `/api/businesses/${selectedBusiness?.id}/recipes` },
    options
  );
}

export default useGetRecipes;